import Vue from 'vue'

export function handleVueError () {
  Vue.config.errorHandler = function (err, vm, info) {
    // console.log(vm)
    console.log('handleVueError:', err)
  }
}

export function catchPromiseError (e) {
  console.log('catchPromiseError:', e)
}
